const generateContactFields = () => {
  const inputInquiry = document.querySelector(".input-inquiry")
  const fieldOrder = document.querySelector(".field__order_number")
  const inputOrder = document.querySelector(".input_order")

  inputInquiry.addEventListener("change", (event) => {
    const index = event.target.options.selectedIndex
    const node = event.target.options[index]
    const toggle = node.dataset.toggle
    if (toggle) {
      // show additional input
      inputOrder.disabled = false
      inputOrder.value = ""
      fieldOrder.style.display = "block"
    } else {
      // hide additional input
      inputOrder.disabled = true
      fieldOrder.style.display = "none"
    }
  })
}

document.addEventListener("DOMContentLoaded", function (event) {
  generateContactFields()
})
